// PLOW section kinds and the labels they suggest.
//
// A board's day splits into sections, each of a kind: an assignment row takes
// a job, a text row a note, a shift time row a start and an end, a person row
// a link to somebody in the directory, a standby row the standby level the
// person is on standby at. Three of those kinds are nearly always used for one
// thing, so picking them fills the label in: shift time becomes "Shift", a
// person row "Project Manager", a standby row "Standby". The label is only ever filled in
// over a blank or over a label this rule wrote earlier, so anything a planner
// typed ("Van crew") stays put when the kind changes underneath it.

export const SECTION_KINDS = ['assignment', 'text', 'shift_time', 'person', 'standby'];

export const SECTION_DEFAULT_LABELS = {
  shift_time: 'Shift',
  person: 'Project Manager',
  standby: 'Standby',
};

const AUTO_LABELS = new Set(Object.values(SECTION_DEFAULT_LABELS));

/** The label a section should carry after its kind changes. */
export function sectionLabelFor(currentLabel, kind) {
  const label = String(currentLabel || '').trim();
  if (label && !AUTO_LABELS.has(label)) return label;
  return SECTION_DEFAULT_LABELS[kind] || '';
}
